if (!customElements.get('english-whisky-gi-article')) {
  customElements.define(
    'english-whisky-gi-article',
    class EnglishWhiskyGiArticle extends HTMLElement {
      connectedCallback() {
        this.progress = this.querySelector('[data-egi-progress]');
        this.onScroll = this.onScroll.bind(this);
        this.syncStickyTop = this.syncStickyTop.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.loadBottlesIfNeeded();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        this.syncStickyTop();
        const start = this.offsetTop;
        const height = this.offsetHeight - window.innerHeight;
        const value = height > 0 ? Math.min(1, Math.max(0, (window.scrollY - start) / height)) : 0;
        if (this.progress) this.progress.style.width = `${value * 100}%`;
      }

      syncStickyTop() {
        const header =
          document.querySelector('#shopify-section-header .header') || document.querySelector('store-header');
        if (!header) return;
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        this.style.setProperty('--egi-header-end', `${bottom}px`);
      }

      isTargetBottle(product) {
        const title = (product.title || '').toLowerCase();
        if (title.includes('golden union')) return true;
        if (title.includes('yesteryear') && (title.includes('rye') || title.includes('london'))) return true;
        if (title.includes('london distillery') && (title.includes('golden') || title.includes('yesteryear'))) {
          return true;
        }
        return false;
      }

      productImage(product) {
        const image = product.featured_image || product.image;
        if (!image) return '';
        if (typeof image === 'string') return image;
        return image.url || image.src || '';
      }

      formatMoney(price, format) {
        if (price == null || price === '') return '';
        const text = String(price);
        if (text.includes('£') || text.includes('$')) return text;
        const cents = Number(text);
        if (Number.isNaN(cents)) return text;
        const amount = (cents / 100).toFixed(2);
        const pattern = format || '£{{amount}}';
        return pattern.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
      }

      async loadBottlesIfNeeded() {
        const slots = Array.from(this.querySelectorAll('[data-egi-bottle-slot]'));
        if (!slots.length || slots.some((slot) => slot.querySelector('[data-egi-product]'))) return;

        const configEl = this.querySelector('[data-egi-search-config]');
        if (!configEl) return;

        let config;
        try {
          config = JSON.parse(configEl.textContent);
        } catch (error) {
          return;
        }

        const queries = config.queries || [];
        const found = new Map();
        const rootUrl = window.Shopify?.routes?.root || '/';

        await Promise.all(
          queries.map(async (query) => {
            try {
              const url = `${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;
              const response = await fetch(url);
              if (!response.ok) return;
              const data = await response.json();
              const products = data?.resources?.results?.products || [];
              products.forEach((product) => {
                if (!this.isTargetBottle(product)) return;
                const key = product.handle || product.url || product.title;
                if (!found.has(key)) found.set(key, product);
              });
            } catch (error) {
              // Search is a fallback until the London Distillery bottles are published.
            }
          })
        );

        if (!found.size) return;

        const items = Array.from(found.values()).sort((a, b) => {
          const aKey = (a.title || '').toLowerCase().includes('golden') ? 0 : 1;
          const bKey = (b.title || '').toLowerCase().includes('golden') ? 0 : 1;
          return aKey - bKey;
        });

        slots.forEach((slot, index) => {
          const product = items[index];
          if (!product) return;
          const image = this.productImage(product);
          const href = product.url || `${rootUrl}products/${product.handle}`;
          const card = document.createElement('a');
          card.className = 'egi-tile';
          card.href = href;
          card.setAttribute('data-egi-product', '');

          const media = document.createElement('div');
          media.className = 'egi-tile__media';
          if (image) {
            const img = document.createElement('img');
            img.src = image;
            img.alt = product.title || '';
            media.appendChild(img);
          }

          const body = document.createElement('div');
          body.className = 'egi-tile__body';
          const heading = document.createElement('h3');
          heading.className = 'egi-tile__title';
          heading.textContent = product.title || '';
          const price = document.createElement('p');
          price.className = 'egi-tile__price';
          price.textContent = this.formatMoney(product.price, config.moneyFormat);
          body.append(heading, price);
          card.append(media, body);
          slot.hidden = false;
          slot.appendChild(card);
        });
      }
    }
  );
}
